export default "__VITE_ASSET__8ba7cac6__"